export const SPONSORSHIP_STATUS = {
  FINALIZED: {
    label: 'Parrainage finalisé',
    color: 'bg-ih-green',
  },
  IN_PROGRESS: {
    label: 'Parrainage en cours',
    color: 'bg-ih-blue',
  },
  NOT_FINALIZED: {
    label: 'Parrainage non finalisé',
    color: 'bg-ih-red',
  },
};

export const EVENTS = [
  { id: 1, label: 'Inscription du filleul' },
  { id: 2, label: 'Signature du mandat' },
  { id: 3, label: 'Acte authentique' }
];

const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleString('fr-FR', { month: 'long', year: 'numeric' });
};

export const getSponsorshipStatus = (sponsorship) => {
  const { sale_state, state_changes: { last_sold_at } } = sponsorship;

  if (sale_state === 'dead') return SPONSORSHIP_STATUS.NOT_FINALIZED;

  if (last_sold_at) return SPONSORSHIP_STATUS.FINALIZED;

  return SPONSORSHIP_STATUS.IN_PROGRESS;
};

export const getEventsForSponsorship = (sponsorship) => {
  const { created_at, state_changes: { last_awaiting_publication_at, last_sold_at }, sale_state } = sponsorship;
  const isDead = sale_state === 'dead';

  return EVENTS.map(({ id, label }) => {
    if (id === 1) {
      return {
        id,
        label,
        date: formatDate(created_at),
        done: true,
        cancelled: false
      };
    }

    if (id === 2) {
      return {
        id,
        label,
        date: formatDate(last_awaiting_publication_at),
        done: !!last_awaiting_publication_at,
        cancelled: isDead && !last_awaiting_publication_at
      };
    }

    return {
      id,
      label,
      date: formatDate(last_sold_at),
      done: !!last_sold_at,
      cancelled: isDead && !last_sold_at
    };
  });
};
